var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.1,5.6h-1.7v-.6c0-1-.9-1.9-1.9-1.9h-8c-1,0-1.9.9-1.9,1.9v.6h-1.7c-1,0-1.8.8-1.8,1.8v1.3c0,1.7.9,3.2,2.4,3.9l1.6.8h0c.8,1.8,2.5,3.1,4.5,3.4v2.3h-3.1c-.5,0-.9.4-.9.9s.4.9.9.9h8c.5,0,.9-.4.9-.9s-.4-.9-.9-.9h-3.1v-2.3c2-.3,3.7-1.6,4.5-3.4l1.6-.8c1.5-.8,2.4-2.3,2.4-3.9v-1.3c0-1-.8-1.8-1.8-1.8ZM6.3,11c-.9-.4-1.4-1.3-1.4-2.3v-1.3s1.7,0,1.7,0v3.6s0,.1,0,.2h-.3ZM20.1,8.7c0,1-.5,1.9-1.4,2.3h-.3c0,0,0,0,0,0v-3.6h1.7s0,1.3,0,1.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.b20354ffc457c964e71bee1731085bd7.svg";
export { ForwardRef as ReactComponent };